// Paleta fija de 20 colores cálidos/pastel, organizados por grupo. Se usa
// para colorear las porciones de los donuts de categoría (en vez de
// generar una escala monocromática calculada, o asignar un icono por
// categoría). Cada tema usa solo los grupos que combinan con su propio
// color de acento, para que los gráficos sigan "sintiéndose" del tema
// activo aunque la paleta en sí sea fija.

export const COLOR_GROUPS = {
  neutros: ["#F5EFE6", "#D6B58A", "#BC8A5F", "#8C6A52"],
  verdes:  ["#8FAF8A", "#6F8C58", "#4E8B6A", "#9FD8C5"],
  azules:  ["#78AEEB", "#A8C8F5", "#4C7A8A", "#526A93"],
  morados: ["#B39DDB", "#C8A2D8", "#8F6BAF"],
  rosas:   ["#D8A1B8", "#C85A8E", "#E88D8D"],
  calidos: ["#C97A44", "#C9A03A"],
};

// Qué grupos de color usa cada tema, en el orden en que se van usando
// (el primer grupo es el "principal" del tema, se repite o se completa con
// el segundo grupo si una categoría necesita más colores que los que
// caben en el grupo principal).
const THEME_COLOR_GROUPS = {
  king:    ["calidos", "neutros"],
  luxe:    ["calidos", "neutros"],
  cafe:    ["neutros", "calidos"],
  elite:   ["calidos", "neutros"],
  sakura:  ["rosas", "morados"],
  neon:    ["rosas", "morados"],
  arcoiris:["rosas", "morados"],
  zafiro:  ["azules"],
  cian:    ["azules"],
  finance: ["azules"],
  menta:   ["verdes"],
  matrix:  ["verdes"],
  // Temas sin un color de acento dominante claro: mezcla variada
  light:   ["neutros", "azules", "verdes", "calidos"],
  dark:    ["neutros", "azules", "verdes", "calidos"],
};

// Devuelve la lista de colores disponibles para el tema dado, juntando
// los grupos que le corresponden (sin duplicados), para usarlos como
// paleta de categorías de un gráfico o selector manual de color.
export function getThemePalette(themeName) {
  const groups = THEME_COLOR_GROUPS[themeName] || THEME_COLOR_GROUPS.light;
  const colors = [];
  groups.forEach((g) => {
    (COLOR_GROUPS[g] || []).forEach((c) => {
      if (!colors.includes(c)) colors.push(c);
    });
  });
  return colors.length ? colors : COLOR_GROUPS.neutros;
}

// Asigna un color de la paleta del tema a cada índice (0, 1, 2...),
// repitiendo la paleta cíclicamente si hay más categorías que colores
// disponibles en los grupos asignados a ese tema.
export function getThemeColorForIndex(themeName, index) {
  const palette = getThemePalette(themeName);
  return palette[index % palette.length];
}
